import * as React from "react";
import {
  ActionIcon,
  Divider,
  Flex,
  Paper,
  Text,
  Title,
  useMantineTheme,
} from "@mantine/core";
import { IconCopy } from "@tabler/icons-react";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { PrismAsyncLight as SyntaxHighlighter } from "react-syntax-highlighter";
import { materialLight } from "react-syntax-highlighter/dist/esm/styles/prism";
import javascript from "react-syntax-highlighter/dist/esm/languages/prism/javascript";
import sql from "react-syntax-highlighter/dist/esm/languages/prism/sql";

SyntaxHighlighter.registerLanguage("javascript", javascript);
SyntaxHighlighter.registerLanguage("sql", sql);

const MarkdownComponents: object = {
  code({ node, inline, className, ...props }: any) {
    const hasLang = /language-(\w+)/.exec(className || "");
    const hasMeta = node?.data?.meta;
    const [isCopied, setIsCopied] = React.useState(false);

    const setCopied = () => {
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 1000);
    };

    return hasLang ? (
      <>
        <Flex>
          <SyntaxHighlighter
            style={materialLight}
            language={hasLang[1]}
            PreTag="div"
            className="codeStyle"
            showLineNumbers={true}
            wrapLines={hasMeta}
            useInlineStyles={true}
          >
            {props.children}
          </SyntaxHighlighter>
          <CopyToClipboard text={props.children}>
            <span title="Copy to Clipboard">
              <ActionIcon
                size="xs"
                variant="transparent"
                color="gray"
                onClick={() => setCopied()}
                disabled={isCopied}
              >
                <IconCopy />
              </ActionIcon>
            </span>
          </CopyToClipboard>
        </Flex>
      </>
    ) : (
      <code className={className} {...props} />
    );
  },
  h3({ node, inline, className, ...props }: any) {
    return <Text fw={500} {...props}></Text>;
  },
  h4({ node, inline, className, ...props }: any) {
    return <Text fw={500} size="sm" {...props}></Text>;
  },
  p({ node, inline, className, ...props }: any) {
    return <Text size="sm" {...props}></Text>;
  },
};
/* 
const Code = ({ node, inline, className, ...props }) => {
  const [isCopied, setIsCopied] = React.useState(false);
  console.log("props", props);

  const hasLang = /lang-(\w+)/.exec(props.className || "");
  console.log("hasLang", hasLang);

  const setCopied = () => {
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  };

  if (hasLang) {
    return (
      <div className="code">
        <div className="code__icons">
          <CopyToClipboard text={props.children}>
            <button onClick={() => setCopied()}>
              {isCopied ? (
                <></>
              ) : (
                <span title="Copy to Clipboard">
                  <IconCopy />
                </span>
              )}
            </button>
          </CopyToClipboard>
        </div>

        <SyntaxHighlighter
          language={hasLang[1]}
          PreTag="div"
          className="codeStyle"
          showLineNumbers={true}
          useInlineStyles={true}
        >
          {props.children}
        </SyntaxHighlighter>
      </div>
    );
  } else {
    return <code className={props.className} {...props} />;
  }
};
 */
export default function Display({
  description,
}: {
  description: string | null | undefined;
}) {
  const theme = useMantineTheme();
  if (description) {
    return (
      <Markdown remarkPlugins={[remarkGfm]} components={MarkdownComponents}>
        {description}
      </Markdown>
    );
  } else {
    return <Divider label="No SOP available" labelPosition="left" />;
  }
}

/* 
export default function SOP(props: any) {
  return <></>;
}
 */
